
// This function calculates icon positions in polar coordinates
function CalculateConnectionChains(data, depth) {

  const connectionChains = {};

  data.forEach(icon => {

    let chainLinks = [];
    let directLinks = [];
    let directIcons = [];
    let chainIcons = [];
    let depthOfIcons = {};

    // calculate direct links
    calcLinks(+icon.ID, directLinks, directIcons, 1, {}, 'forward');
    calcLinks(+icon.ID, directLinks, directIcons, 1, {}, 'backward');

    // calculate all icons in the chain with a depth set to a high number
    calcLinks(+icon.ID, chainLinks, chainIcons, depth, depthOfIcons, 'forward');
    calcLinks(+icon.ID, chainLinks, chainIcons, depth, depthOfIcons, 'backward');

    connectionChains[+icon.ID] = {
      'chainLinks':chainLinks,
      'directLinks':directLinks,
      // slice(1) omdat icon.ID zelf er 2x inzit. Eigenlijk een bugje nog
      'directIcons':directIcons,
      'chainIcons':chainIcons,
      'depthOfIcons':depthOfIcons
    }
    // if(icon.ID === '17'){
    //   console.log(chainLinks)
    // }

  })

  // this function will add all direct forward links to links and all icons up to a given
  // depth to the icons list
  function calcLinks(currentIcon, links, icons, depth, depthOfIcons, forward_backward){
    let currentLinks = [currentIcon];
    let newLinks = [];
    let linkedIcon = '';
    let currentDepth = 1;

    while((currentLinks.length !== 0 || newLinks.length !== 0)){

      // if the currentLinks list is empty, go one level deeper and set
      // currentLinks to newLinks
      if(currentLinks.length === 0 && newLinks.length > 0){
        currentLinks = newLinks;
        newLinks = [];
        currentDepth += 1;
      }

      // console.log(currentLinks)

      linkedIcon = currentLinks.pop();

      icons.push(linkedIcon);
      if(
        !(linkedIcon in depthOfIcons) ||
        (linkedIcon in depthOfIcons && currentDepth < depthOfIcons[linkedIcon])
      ){
        depthOfIcons[linkedIcon] = currentDepth;
      }

      if(currentDepth <= depth){
        if(forward_backward === 'forward'){
          getForwardLinks(data, linkedIcon, links, newLinks, icons);
        }else{
          getBackwardLinks(data, linkedIcon, links, newLinks, icons);
        }
      }
    }
  }

  function getForwardLinks(data, linkedIcon, links, newLinks, icons){
    // get the forward linked icons
    const newIcons = data.filter(d => +d.ID === linkedIcon)[0]["Pijlen naar (ID's)"].split(',');
    // console.log(newIcons)
    // check if newIcons is not just [""], a list with an empty string
    if(!(newIcons.length === 1 && newIcons[0] === "")){
      newIcons.forEach(newIcon => {

        // only add the link if it is a direct link
        links.push(linkedIcon + '_to_' + newIcon);

        // if the icon is not already in the icons list, add it to the
        // forwardLinks
        // let count = 0;
        // icons.forEach(_icon => {
        //     if(_icon === +newIcon){
        //       count += 1;
        //     }
        // });
        // if(count < 10){
        //   newLinks.push(+newIcon)
        // }
        if(!(icons.includes(+newIcon))){
          newLinks.push(+newIcon)
        }
      });
    }
  }

  function getBackwardLinks(data, linkedIcon, links, newLinks, icons){
    // for each icon check if has a link forward to linkedIcon
    data.forEach(row => {
      if(row["Pijlen naar (ID's)"].split(',').includes(String(linkedIcon))){
        // only add the direct links
        links.push(row.ID + '_to_' + linkedIcon);

        // if the icon is not already in the icons list or the newLinks list,
        // add it to the newLinks
        let count = 0;
        icons.forEach(_icon => {
          if(_icon === +row.ID){
            count += 1;
          }
        });
        if(count < 2){
          newLinks.push(+row.ID)
        }
        // if(
        //   !(
        //     icons.indexOf(+row.ID) > -1 ||
        //     newLinks.indexOf(+row.ID) > -1
        //   )
        // ){
        //   newLinks.push(+row.ID)
        // }
      }
    });
  }

  return connectionChains;
}

export default CalculateConnectionChains;
